import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { usePortal } from "../../../Providers/PortalProvider";
import { Popup, PopupActions, PopupButton, PopupContent, PopupHeading, } from "../../../components/Common/Popup";
const NotReceivedCodeDialog = ({ onClose }) => {
    const { t } = useTranslation();
    const portal = usePortal();
    return (React.createElement(Popup, { maxWidth: "xs" },
        React.createElement(PopupHeading, null,
            React.createElement(Trans, null, "Not received your code?")),
        React.createElement(PopupContent, null,
            React.createElement("p", null, t("All students at schools that have been photographed by %s will receive an SMS, letter or an email after the photo shoot once the images are ready. They will contain with instructions on how to photos and order prints.", {
                postProcess: "sprintf",
                sprintf: [portal.name],
            })),
            React.createElement("p", null, t("Have your friends received their pictures and you have not? Please contact us at %s with name of the photographed, group and location for the shoot. Remember to include your name and how to best contact you. We will then help you get access to your pictures!", {
                postProcess: "sprintf",
                sprintf: [portal.contactInfo.email],
            }))),
        React.createElement(PopupActions, null,
            React.createElement(PopupButton, { onClick: onClose },
                React.createElement(Trans, null, "Ok")))));
};
export default NotReceivedCodeDialog;
